export default __webpack_public_path__ + "static/media/b1_jelen_lesni-min.7a31c68b.jpg";